const formFields = [
  { type: 'name', placeholder: 'Your Name', category: 'name' },
  { type: 'email', placeholder: 'Your Email', category: 'email' },
  { type: 'text', placeholder: 'Your Subject', category: 'subject' },
  { type: 'textarea', placeholder: 'Your Message', category: 'message' },
];

export default formFields;
